import { login, recoverAccount, sendEmailForgetPassword } from 'services/auth';
import {
  ERROR_CODES,
  TWO_FACTOR_AUTH_ENABLED_STATUS_CODE
} from 'constants/login';
import { sendSegment } from 'utils/segment';
import { getAccountTypePropForSuccessMetrics } from './helpers';
import { LOCALE } from 'constants/intl-wrapper';
import { openModal } from './modal';

import { notify } from 'components/Notify/Notify';
import ActivationModal from 'components/BRModals/ActivationModal/ActivationModal';

import BostaLogo from 'assets/images/bosta_logo.svg';
import bostaLogoArabic from 'assets/images/bosta_arabic.svg';
import BRSecurityOtpModal from 'components/BRSecurityOtpModal/BRSecurityOtpModal';

const redirect = (isExistingUser) => {
  isExistingUser
    ? window.location.replace('/sllr/store' + window.location.search)
    : window.location.reload();
};

const handleAfterLoginSuccessfully = ({
  userInfo,
  location,
  history,
  intl,
  isExistingUser
}) => {
  sendSegment('E_BUSINESS_SIGNIN', {
    email: userInfo.user.emails[0].address,
    roles: userInfo.user.roles[0],
    'Business Name':
      userInfo.user.businessAdminInfo !== undefined
        ? userInfo.user.businessAdminInfo.businessName
        : null,
    phone: userInfo.user.profile.phone || '',
    Name: `${userInfo.user.profile.firstName} ${
      userInfo.user.profile.lastName ? userInfo.user.profile.lastName : ''
    }`,
    businessId:
      userInfo.user.businessAdminInfo?.businessId !== undefined
        ? {
            id: userInfo.user.businessAdminInfo?.businessId,
            name: userInfo.user.businessAdminInfo?.businessName
          }
        : null,
    'Business Type': userInfo.user.monthlyShipmentVolume || ''
  });
  // if (
  //   window.location.hostname === PRODUCTION_URL &&
  //   userInfo.user.businessAdminInfo &&
  //   userInfo.user.businessAdminInfo?.isBetaUser
  // ) {
  //   window.open(
  //     `${BETA_URL_REDIRECT}${userInfo.token.replace('Bearer ', '')}`,
  //     '_parent'
  //   );
  // }
  const { user = {} } = userInfo;
  if (userInfo) {
    if (!userInfo?.user?.businessAdminInfo?.businessId) {
      return openModal(ActivationModal, {
        icon: (
          <div className="br-sigin__activate-first-title">
            <span className="display-sm">
              {intl.formatMessage({
                id: 'login.activate_first_modal.title'
              })}
            </span>
            <img
              src={intl.locale === LOCALE.AR ? bostaLogoArabic : BostaLogo}
              className="br-sigin__activate-first-img"
              alt=""
            />
          </div>
        ),
        subtitle: (
          <div className="br-sigin__activate-first-subtitle">
            <span className="button">
              {intl.formatMessage({
                id: 'login.activate_first_modal.good_news'
              })}
            </span>
            {intl.formatMessage({
              id: 'login.activate_first_modal.subtitle'
            })}
          </div>
        ),
        buttonText: intl.formatMessage({
          id: 'new_header.orders.activation_modal.buttonText'
        }),
        hideCancelButton: true,
        wrapClassName: 'br-signin__activate-first',
        onOk: () => {
          window.open(
            `https://business.bosta.co/business-information`,
            '_parent'
          );
        }
      });
    }

    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    localStorage.setItem('newToken', userInfo.token);
    localStorage.setItem(
      'isRegisteredHekouky',
      !!userInfo?.user?.businessAdminInfo?.hekoukyProfileInfo?.isRegistered
    );

    const userIdentifer = userInfo.user.businessAdminInfo?.businessName
      ? userInfo.user.businessAdminInfo?.businessName
      : userInfo.user.emails[0].address;

    window?.analytics?.identify(userIdentifer, {
      'User Email': user.emails[0].address,
      Permission: user?.group?.name,
      'Business Name':
        user.businessAdminInfo !== undefined
          ? user?.businessAdminInfo?.businessName
          : null,
      Phone: user.profile.phone || '',
      'Business Type': user.monthlyShipmentVolume || '',
      'Dashboard Language': intl.locale
    });

    sendSegment(
      'Step1_Successful-sign-in',
      getAccountTypePropForSuccessMetrics()
    );
  }
  if (location.search === '?payment') {
    history.push('/settings/payment-info');
  } else if (location.state && location.state.pathName) {
    const {
      state: { pathName, pathSearch = '', pathState = undefined }
    } = location;
    window.history.replaceState(
      pathState,
      null,
      `${pathName}${pathSearch ? `${pathSearch}` : ''}`
    );
    redirect(isExistingUser);
  } else {
    redirect(isExistingUser);
  }
};

export const userLogin = async ({
  email,
  password,
  setIsLoading,
  history,
  intl,
  isExistingUser = false,
  restoreAccount = false
}) => {
  const { location } = history;
  try {
    setIsLoading(true);

    const payload = {
      email: email.toLowerCase().trim(),
      password: password
    };

    const serviceToCall = restoreAccount ? recoverAccount : login;
    let userInfo = await serviceToCall(payload);

    if (userInfo.status === TWO_FACTOR_AUTH_ENABLED_STATUS_CODE) {
      setIsLoading(false);
      openModal(BRSecurityOtpModal, {
        title: intl.formatMessage({
          id: 'login.security_otp_screen.title'
        }),
        subtitle: intl.formatMessage({
          id: 'login.security_otp_screen.subtitle'
        }),
        noCloseModal: false,
        numberOfDigits: 6,
        confirmOTP: async ({ OTP }, handleInvalidOTP) => {
          try {
            userInfo = await serviceToCall({ ...payload, otp: OTP.toString() });
            handleInvalidOTP({ isInValid: false });
            handleAfterLoginSuccessfully({
              userInfo,
              location,
              history,
              intl,
              isExistingUser
            });
          } catch (error) {
            handleInvalidOTP({ isInValid: true });
            // notify({ msg: error.message });
          }
        }
      });
    } else {
      handleAfterLoginSuccessfully({
        userInfo,
        location,
        history,
        intl,
        isExistingUser
      });
    }
  } catch (error) {
    const { errorCode, data } = error;
    setIsLoading(false);
    if (
      [ERROR_CODES.USER_NOT_FOUND, ERROR_CODES.NOT_VALID].includes(errorCode)
    ) {
      notify({
        msg: intl.formatMessage({ id: 'login.not_valid_input' }),
        error
      });
    } else if (errorCode === ERROR_CODES.DELETED_ACCOUNT) {
      history.push({
        pathName: '/signin',
        state: {
          firstName: data.profile.firstName,
          lastName: data.profile.lastName,
          userType: data.regSrc,
          email,
          password,
          restoreAccount: true
        }
      });
    } else if (errorCode === ERROR_CODES.PASSWORD_EXPIRED) {
      await sendEmailForgetPassword(email);
      notify({
        msg: intl.formatMessage({
          id: 'login.set_new_passowrd.expired_error_message'
        })
      });
      history.push({
        pathname: '/confirm-reset-password',
        state: {
          email,
          isPasswordExpired: true
        }
      });
    } else {
      notify({ msg: error.message, error });
    }
  }
};

export const getSignInPath = () => `/signin`;
